import { render, staticRenderFns } from "./PropertyAmount.vue?vue&type=template&id=77e037f0&scoped=true"
import script from "./PropertyAmount.vue?vue&type=script&lang=ts"
export * from "./PropertyAmount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e037f0",
  null
  
)

export default component.exports